import * as types from "./constants";

/*
 state: {
   showSpinny: false or true, // rest api get
   // side menu and quota for all sims
   sims: [
     {kio: "kioxxx", label: "blah", quota: 45MB},

   ]
   // null or packet logs
   packetLogs: null or {
     kio: "",
     packets: ""
   }
   // null or coupon history
   couponHistory: null or {
   }
 }

 */

export const LOGIN_ERROR_NONE = 0;
export const LOGIN_ERROR_PASSWORD = 1;
export const LOGIN_ERROR_SERVICE = 2;

const initialState = {
  // global
  showSpinny: false,
  // logged out
  initialLoad: true,
  showLogin: true,
  showLoginError: LOGIN_ERROR_NONE,
  // logged in
  showError: false,
  sims: [],
  packetLogs: null,
  couponHistory: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case types.LOGOUT_SHOWMESSAGE:
      return {
        ...initialState,
        initialLoad: false,
        showLogin: action.showLogin, // bool
        showLoginError: action.showLoginError // int
      };

    case types.SHOW_ERROR:
      return {
        ...state,
        showError: action.showError,
      };

    case types.SHOW_SPINNY:
      return {
        ...state,
        showSpinny: action.showSpinny,
      };

    case types.SET_SIMS:
      return {
        ...state,
        sims: action.sims,
      };

    case types.SET_COUPONHISTORY:
      return {
        ...state,
        couponHistory: action.couponHistory,
      };

    case types.SET_PACKETLOGS:
      return {
        ...state,
        packetLogs: action.packetLogs,
      };

    default:
      return state;
  }
}